import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Check if admin has exceeded action limit
 * @param {string} adminId - Admin's user ID
 * @param {string} action - Action type (teamNameChange, userDeletion, userMove)
 * @returns {Promise<{allowed: boolean, count: number, max: number, remaining: number}>}
 */
export const checkAdminActionLimit = async (adminId, action) => {
  const limits = {
    teamNameChange: { max: 5, period: 'hour' },
    userDeletion: { max: 20, period: 'hour' },
    userMove: { max: 50, period: 'hour' },
  };
  
  const limit = limits[action];
  if (!limit) {
    return { allowed: true, count: 0, max: Infinity, remaining: Infinity };
  }
  
  const hourBucket = Math.floor(Date.now() / 3600000);
  const limitDocId = `${adminId}_${action}s_${hourBucket}`;
  
  try {
    const limitDoc = await getDoc(doc(db, 'adminActionLimits', limitDocId));
    
    if (!limitDoc.exists()) {
      return { allowed: true, count: 0, max: limit.max, remaining: limit.max };
    }
    
    const count = limitDoc.data().count || 0;
    const allowed = count < limit.max;
    
    return {
      allowed,
      count,
      max: limit.max,
      remaining: Math.max(0, limit.max - count),
    };
  } catch (error) {
    console.error('Error checking rate limit:', error);
    // On error, allow action (lenient approach)
    return { allowed: true, count: 0, max: limit.max, remaining: limit.max };
  }
};
